import { onDelete } from "../../../function/onDelete";
import { deleteInvite } from "./query";

export default async function onDeleteInvite({
  selectionModel,
  setSelectionModel,
  client,
  values,
}) {
  if (selectionModel) {
    await Promise.all(
      selectionModel?.map(async (items) => {
        await deleteSingleItem(items, client);
      })
    );
    setSelectionModel && setSelectionModel([]);
  } else if (values) {
    await deleteSingleItem(values, client);
  }
}

async function deleteSingleItem(item, client) {
  // console.log({ item, client });
  const { id } = item || {};

  await onDelete({
    input: { id },
    mutation: deleteInvite,
    // updateCacheFields: ["listEntities"],
    client,
  });
}
